import React, {Component} from 'react';
import DocumentBrowserApp from './DocumentBrowserApp';

const styles = {
  root: {
    flexGrow: 1
  }
};

/**
 * Component class of archive app.
 *
 * @return {String} - The component contents.
 */
export default class ArchiveApp extends Component {
  // eslint-disable-next-line require-jsdoc
  constructor(props) {
    super(props);
  }

  /**
   * React render function.
   *
   * @return {String} - The component contents.
   */
  render() {
    return (
      <div id='root' style={styles.root}>
        <DocumentBrowserApp />
      </div>
    );
  }
}
